/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Services{
    angular.module("meevo.plugins.services", []);
}